
export const tariffWebhookTitles: Record<string, string> = {
  weekly: "Аренда неделя",
  biweekly: "Аренда 2 недели",
  monthly: "Аренда месяц",
  "rent-to-own": "Аренда с выкупом",
};

export const tariffs = [
  {
    key: "weekly",
    title: "Неделя",
    price: 4500,
    period: "неделя",
    description: "Без залога",
    perks: [
      "ЯндексТакси за Ваш счет",
      "Техподдержка 24/7",
      "Замена батареи"
    ],
  },
  {
    key: "biweekly",
    title: "2 недели",
    price: 8000,
    period: "2 недели",
    description: "Скидка 11%",
    perks: [
      "ЯндексТакси за Ваш счет",
      "Техподдержка 24/7",
      "Замена батареи"
    ],
  },
  {
    key: "monthly",
    title: "Месяц",
    price: 14000,
    period: "месяц",
    description: "Скидка 22%",
    perks: [
      "Приоритетная поддержка",
      "Бесплатное ТО",
      "Замена батареи"
    ],
  },
  {
    key: "rent-to-own",
    title: "Аренда с выкупом",
    price: 20000,
    period: "первый взнос",
    description: "",
    perks: [
      "Рассрочка на 6 месяцев",
      "Бесплатный гарантийный ремонт",
      "Переход в собственность",
      "Поддержка 24/7"
    ],
  },
];
